export const get_domain_server = async () => {
    const {headers} = require("next/headers");
    const headers_list = await headers();
    return headers_list.get('host') || ""
}

export const get_photo_address_server = () => {
    return process.env.SERVER_PHOTO_ADDRESS
}

export const get_env_domain_server = () => {
    return process.env.SITE_DOMAIN
        ?.replace("http://", "")
        ?.replace("https://", "")
        ?.replace("/", "");
}

export const is_localhost_server = async () => {
    const domain = await get_domain_server();
    return !!((domain?.includes('localhost') || domain?.includes('127.0.0.1')))
}

export const get_protocol_server = async () => {
    const {headers} = require("next/headers");
    const headers_list = await headers();
    return headers_list.get('x-forwarded-proto') || ""
}

export const get_full_url_server = async () => {
    const {headers} = require("next/headers");
    const headers_list = await headers();
    return headers_list.get('x-url') || "";
}

export const get_pathname_server = async () => {
    const {headers} = require("next/headers");
    const headers_list = await headers();
    return String(headers_list.get('x-pathname'))
}

// The current path without its language prefix (`/en/x/` → `/x/`, `/faq/` stays), the path `generate_metadata` and
// `init_page_server` ask the backend for. chawk-bazar / ciseco built it in their own `seoPath.js` to share the seo-json key.
export const get_pathname_without_locale_server = async () => {
    const { strip_locale_prefix } = require("@core/helpers/locale-rules");
    const { get_current_locate_from_cookie } = require("@core/helpers/locate");
    const pathname = await get_pathname_server();
    return strip_locale_prefix(pathname, await get_current_locate_from_cookie()) || "/";
}

export const get_origin_server = async () => {
    const {headers} = require("next/headers");
    const headers_list = await headers();
    return headers_list.get('x-origin')
}

// visitor ip as set by the nginx in front of this site; null when unknown, never a placeholder
export const get_ip_server = async () => {
    const {headers} = require("next/headers");
    const headers_list = await headers();
    const ip = (headers_list.get('x-real-ip') || headers_list.get('x-forwarded-for')?.split(',')?.[0] || '').trim();
    return /^[0-9a-fA-F:.]{3,45}$/.test(ip) ? ip : null;
}

